module.exports = __webpack_public_path__ + "static/img/3.001c2d4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/3/eng/3.png
// module id = Pk61
// module chunks = 0